export const POD_PREVIEW_DROPPABLE_PREFIX = 'pod-preview';

export const toPodPreviewDroppableId = (seqIndex: number, podPosition: string, alignment: string): string =>
  `${POD_PREVIEW_DROPPABLE_PREFIX}|${seqIndex}|${podPosition}|${alignment}`;

export const isPodPreviewDroppableId = (id: string): boolean => id.startsWith(`${POD_PREVIEW_DROPPABLE_PREFIX}|`);

export const parsePodPreviewDroppableId = (
  id: string
): { seqIndex: number; podPosition: string; alignment: string } => {
  const [, rawSeqIndex, podPosition, alignment] = id.split('|');
  return { seqIndex: Number(rawSeqIndex), podPosition, alignment };
};
